
export default (store, to, from, next) => {
  if (store.state.app.demo === true) {
    next();
  }
  if (store.state.app.demo === false && to.name === 'setPin') {
    if (store.state.client.msisdn.length < 10) {
      next('setNumber');
    } else {
      next();
    }
  } else {
    next();
  }
};



// WEBPACK FOOTER //
// ./src/middlewares/EnterToPin.js